export class ForgeProjectFeatureSandbox {
    constructor(model) {
        this.id = model.id;
        this.url = model.url;
        this.parentMessageId = model.parentMessageId;
        this.currentIterationId = model.currentIterationId;
        this.featureId = model.featureId;
        this.expiresAt = new Date(model.expiresAt);
        this.error = model.error;
    }
    toRemote() {
        return {
            ...this,
            expiresAt: this.expiresAt.toISOString(),
        };
    }
}
